import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ModalPagamentoComponent } from '../../solicite-pedido-pre-pago/modal-pagamento/modal-pagamento.component';

@Component({
  selector: 'ngx-modal-pedido-gerado',
  templateUrl: './modal-pedido-gerado.component.html',
  styleUrls: ['./modal-pedido-gerado.component.scss']
})
export class ModalPedidoGeradoComponent implements OnInit {

  @Input() pedidoId: any;
  @ViewChild("card", null)
  private card: ElementRef;
  public customLogin = null;
  constructor(protected ref: NbDialogRef<ModalPagamentoComponent>,) { }

  ngOnInit() {
    this.customLogin = JSON.parse(localStorage.getItem('bway-customLogin'));
    this.card.nativeElement.ownerDocument.activeElement.blur();
  }


  closeModal() {
    this.ref.close();
  }


  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }


}
